export const projects = [
    {
        id: 1,
        title: "JCPG MarketWatch",
        img: "https://raw.githubusercontent.com/GRiveroll86/JCPGMarketWatch/main/assets/Photos/Crypto.PNG",
        link: "https://jcgasper.github.io/JCPGMarketWatch/stockticker.html",
        repo: "https://github.com/GRiveroll86/JCPGMarketWatch"
    },
    {
        id: 2,
        title: "I Choose Who?",
        img: "https://raw.githubusercontent.com/GRiveroll86/I-Choose-Who/main/assets/recommendations-pokemon.png",
        link: "https://blooming-basin-23447.herokuapp.com/",
        repo: "https://github.com/GRiveroll86/I-Choose-Who"
    },
    {
        id: 3,
        title: "What You Tryna Watch?",
        img: "https://cdn.pixabay.com/photo/2014/11/30/14/11/cat-551554_960_720.jpg",
        link: "https://protected-thicket-50731.herokuapp.com/",
        repo: "https://github.com/cbarnes1232/What-you-tryna-watch"
    },
    {
        id: 4,
        title: "Weather Dashboard",
        img: "https://raw.githubusercontent.com/GRiveroll86/weather/master/assets/images/preview.png",
        link: "https://griveroll86.github.io/weather/",
        repo: "https://github.com/GRiveroll86/weather"
    },
    {
        id: 5,
        title: "Note Taker",
        img: "https://raw.githubusercontent.com/GRiveroll86/note-taker/master/assets/preview1.png",
        link: "https://ancient-cove-61796.herokuapp.com/",
        repo: "https://github.com/GRiveroll86/note-taker"
    },
    {
        id: 6,
        title: "Workday Scheduler",
        img: "https://raw.githubusercontent.com/GRiveroll86/scheduler/master/assets/images/preview.png",
        link: "https://griveroll86.github.io/scheduler/",
        repo: "https://github.com/GRiveroll86/scheduler"
    },
]